module.exports = __webpack_public_path__ + "media/images/products/products/v1-23af8dce89253df2d6faf4f57aac2253.jpg";